<main>
    <div class="dashboard-container">
        <div class="tenant-header">
            <buyer-tenant-header></buyer-tenant-header>
        </div>
        <div class="user-header">
            <buyer-user-header></buyer-user-header>
        </div>
        <div class="content">
            <breadcrumb></breadcrumb>
            <router-outlet></router-outlet>
            <div class="footer" [class.signing]="hideFooter" [class.upload]="isUpload">
                <app-footer></app-footer>
            </div>
        </div>
        <ng-container *ngIf="!hideSideNav">
            <div class="side-nav">
                <buyer-side-nav></buyer-side-nav>
            </div>
        </ng-container>
    </div>
</main>
